import { Config } from "../Config";
import { post } from "../Components/misc/api";

interface FeedbackFormRequest {
    experienceWithTheSiteScore: number;
    experienceWithTheSiteLabel: string;
    comment: string;
    captchaToken: string;
}

export interface FeedbackFormValidationError {
    experienceWithTheSiteScore: string;
    experienceWithTheSiteLabel: string;
    comment: string;
    captchaToken: string;
}

export interface FeedbackFormGeneralError {
    message: string;
}

export interface FeedbackFormSuccess {
    userCount: number;
}

export interface FeedbackFormResponse {
    success: boolean;
    error?: "validation" | "captcha" | "sender";
    data: Partial<FeedbackFormValidationError> | FeedbackFormGeneralError | FeedbackFormSuccess;
}

export interface FeedbackFormHTTPError {
    code: string;
    message: string;
    statusCode: number;
}

export const feedbackFormSubmit = async (request: FeedbackFormRequest) => {
    if (!request) throw new Error("Feeback from request cannot be null");

    const response = await post<FeedbackFormResponse>(`${Config.mapApi}/feedback`, JSON.stringify(request));
    return response;
};
